(function () {
  'use strict';

  // Idempotenz: Script läuft pro Section → sonst mehrfaches cart-add pro Klick
  if (window.__supplementaProductGridLoaded) return;
  window.__supplementaProductGridLoaded = true;

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.classList || !form.classList.contains('spg-card__form')) return;

    e.preventDefault();

    // In-Flight-Guard gegen Doppel-Submit per Enter (button.disabled reicht nicht)
    if (form.dataset.submitting === '1') return;
    form.dataset.submitting = '1';

    var btn = form.querySelector('.spg-card__btn');
    var originalLabel = btn ? btn.innerHTML : '';
    if (btn) {
      btn.disabled = true;
      btn.dataset.label = originalLabel;
      btn.innerHTML = '…';
    }

    var formData = new FormData(form);
    formData.append('sections_url', window.location.pathname);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    })
      .then(function (res) {
        if (!res.ok) {
          return res.json().then(function (data) {
            throw new Error(data && data.description ? data.description : 'Add to cart failed');
          });
        }
        return res.json();
      })
      .then(function (data) {
        if (window.SAnalytics) {
          window.SAnalytics.productAddedToCart(data, Number(formData.get('quantity')) || 1);
        }
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', {
          bubbles: true,
          detail: { opener: btn }
        }));
      })
      .catch(function (err) {
        console.error('[supplementa-product-grid]', err);
        if (btn) {
          btn.innerHTML = 'Fehler';
          setTimeout(function () { if (btn) btn.innerHTML = btn.dataset.label || originalLabel; }, 1800);
        }
      })
      .finally(function () {
        setTimeout(function () {
          form.dataset.submitting = '';
          if (btn) {
            btn.disabled = false;
            if (btn.innerHTML === '…') btn.innerHTML = btn.dataset.label || originalLabel;
          }
        }, 400);
      });
  });
})();
